import { render } from "./VUSVizualiser.vue?vue&type=template&id=96b0fd56"
import script from "./VUSVizualiser.vue?vue&type=script&lang=js"
export * from "./VUSVizualiser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__